import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import constants from '../ndbk-constants'
import Toggler from './Toggler'
import * as d3 from "./d3.modified.js"

class PermissionsManager extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            users: this.props.users || [],
            groups: [],
            addMemberInput : "",
            userSearchResults: [],
            isGroupMove: false,
            isMoveDone: false,
        }

        this.state.users.sort((a,b)=>{
            if (a.username===this.props.currentUser.username) return -1
            if (b.username===this.props.currentUser.username) return 1
            if (this.props.authLevel[a.permissions]>this.props.authLevel[b.permissions]) return -1
            if (this.props.authLevel[a.permissions]<this.props.authLevel[b.permissions]) return 1
            return 0
        })
    }
    componentWillMount() {
        if (!this.props.isGroupPage) {
            this.fetchNodebookUsers()
        }
    }

    componentDidMount() {
        if (this.props.isGroupPage) {
            d3.select(this.wrapper)
                .style('opacity', 0)
                .transition()
                    .duration(500)
                    .style('opacity', 1)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.users) {
            var nextUsers = nextProps.users
            nextUsers.sort((a,b)=>{
                if (a.username===this.props.currentUser.username) return -1
                if (b.username===this.props.currentUser.username) return 1
                if (this.props.authLevel[a.permissions]>this.props.authLevel[b.permissions]) return -1
                if (this.props.authLevel[a.permissions]<this.props.authLevel[b.permissions]) return 1
                return 0
            })
            this.setState({
                users: nextUsers
            })
        }

    }

    fetchNodebookUsers = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/users`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: (this.props.isGroupPage)
                ?undefined
                :JSON.stringify({
                    shareToken: this.props.getShareTokenFromParams()
                }),
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({users: response.data})
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            })
    }

    fetchUserGroups = () => {
        fetch(`https://${constants.SERVER_IP}/api/groups/admin`, {
            credentials: 'include',
            method: 'GET'
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({
                        groups: response.data,
                        isGroupMove: true,
                    })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            })
    }

    moveNodebookToGroup = (id) => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}/move-to/group/${id}/`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.success) {
                //this.fetchNodebookUsers()
                this.setState({
                    isMoveDone: true,
                    isGroupMove: false,
                })
            }})
        .catch((error) => {
                console.error(error);
        });
    }

    updateMember(id, permissions) {
        let type = (this.props.isGroupPage) ? 'group' : 'nodebook'
        fetch(`https://${constants.SERVER_IP}/api/${type}/${this.props.match.params.id}/user/${id}/update/`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({permissions:permissions})
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.success) {
                //this.fetchNodebookUsers()
            }})
        .catch((error) => {
                console.error(error);
        });
    }

    deleteMember(id) {
        let type = (this.props.isGroupPage) ? 'group' : 'nodebook'
        fetch(`https://${constants.SERVER_IP}/api/${type}/${this.props.match.params.id}/user/${id}/delete/`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {

                    //this.fetchNodebookUsers()
                }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    addMember = (id) => {
        let type = (this.props.isGroupPage) ? 'group' : 'nodebook'
        fetch(`https://${constants.SERVER_IP}/api/${type}/${this.props.match.params.id}/user/${id}/add/`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {
                    //this.setState({addMemberInput:'', userSearchResults:[]})
                    //this.fetchNodebookUsers()
                }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    onInputChange = (e) => {

        let text = e.target.value;
        if (text.length > 0) {
            this.setState({addMemberInput:text})
            fetch(`https://${constants.SERVER_IP}/api/search/users/${text}`, {
                method: 'GET',
                credentials: 'include',
            })
                .then((response)=>response.json())
                .then((response)=>{
                    if (response.success) {
                        this.setState({userSearchResults:response.data.filter( value =>{
                            // Check if user is already in group
                            for (let i = 0; i < this.state.users.length; i++ ) {
                                let user = this.state.users[i]
                                if (value.id === user.id) return false
                            }
                            return true
                            })
                        })
                    }
                })
                .catch((err)=>
                {
                })
        } else {
            this.setState({addMemberInput:text, userSearchResults:[]})
        }
    }

    render() {
        var canChange = (this.props.permissions && this.props.authLevel[this.props.permissions]>5)

        var usersJSX = null
        // pripada grupi
        if (this.props.groupId || !canChange) {
            usersJSX = this.state.users.map(
                member => (
                       <div key={member.username} className="user noaction">
                            <div className="avatar" style={{backgroundImage: `url(${member.avatar})`}}></div>
                            <Link to={`/user/${member.username}`}>
                                <div className="name">
                                    {member.first_name} {member.last_name}
                                    <small>{member.username}</small>
                                </div>
                            </Link>
                            <div className="level">{({admin:'Admin', editor:'Editor', view:'View'})[member.permissions]}</div>
                        </div>
                )
            )
        } else {
            usersJSX = (
                this.state.users.map(
                    (member, index) => (
                            <div key={member.username} className={"user"+(member.username===this.props.currentUser.username?' noaction':'')}>
                                <div className="avatar" style={{backgroundImage: `url(${member.avatar})`}}></div>
                                <Link to={`/user/${member.username}`}>
                                    <div className="name">
                                        {member.first_name} {member.last_name}
                                        <small>{member.username}</small>
                                    </div>
                                </Link>
                                {
                                (member.username===this.props.currentUser.username)
                                    ? <div className="level">{({admin:'Admin', editor:'Editor', view:'View'})[member.permissions]}</div>
                                    : [
                                        <Toggler
                                            key="togaler"
                                            title="Click to toggle"
                                            className="level toggler"
                                            default={member.permissions}
                                            values={{admin:'Admin', editor:'Editor', view:'View'}}
                                            onChange={val=>{this.updateMember(member.id, val)}}
                                        />,
                                        <span key="spen" className="remove" title="Remove user's permissions" onClick={()=>{
                                            let members = this.state.users
                                            members.splice(index, 1)
                                            this.setState({users:members})
                                            this.deleteMember(member.id)}
                                        }>
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                                            </svg>
                                        </span>
                                    ]
                                }
                            </div>
                    )
                )
            )
        }

        if (this.props.groupId) {
            return (
                <div className="permissionsmngr" ref={c=>this.wrapper=c}>
                    <p>This nodebook is created within a group. <br/>To update permissions, go to the <Link style={{color:'#4285F4'}} to={`/group/${this.props.groupId}/members`}>group's page</Link>.</p>
                    {usersJSX}
                </div>
            )
        } else {
            if (canChange) {
                return (
                    <div className="permissionsmngr" ref={c=>this.wrapper=c}>
                        <input ref={c => { this.addMemberInputRef = c; }} type="text" value={this.state.addMemberInput} placeholder="Add user ..." onChange={this.onInputChange}/>
                        {
                            (this.state.addMemberInput === '')
                                ? usersJSX
                                : this.state.userSearchResults.map(
                                        (member, index) => (
                                                <div key={member.username} className="user noaction">
                                                    <div className="avatar" style={{backgroundImage: `url(${member.avatar})`}}></div>
                                                    <Link to={`/user/${member.username}`}>
                                                        <div className="name">
                                                            {member.first_name} {member.last_name}
                                                            <small>{member.username}</small>
                                                        </div>
                                                    </Link>
                                                    <span
                                                        title="Add user"
                                                        className="level"
                                                        onClick={()=>{
                                                            this.addMemberInputRef.focus();
                                                            let users = [{...member, permissions: 'view'}, ...this.state.users]
                                                            let userSearchResults = this.state.userSearchResults
                                                            userSearchResults.splice(index, 1)
                                                            this.setState({users: users, addMemberInput:'', userSearchResults:[]})
                                                            this.addMember(member.id, member)
                                                        }}
                                                        style={{cursor: 'pointer'}}
                                                    ><span className="btn">Add</span></span>
                                                    {
                                                    //<div className="level">{({admin:'Admin', editor:'Editor', view:'View'})[member.permissions]}</div>
                                                    }
                                                </div>
                                        )
                                    )
                        }
                        {
                            (!this.props.isGroupPage)
                                ? (!this.state.isGroupMove)
                                    ? (
                                        (!this.state.isMoveDone)
                                            ? <a onClick={()=>{this.fetchUserGroups()}}>Move nodebook to a group</a>
                                            : <p>Nodebook moved.</p>
                                    ) : (
                                        <div>
                                            <hr style={{marginTop: '5px', marginBottom: '5px'}}/>
                                            <a onClick={()=>{this.setState({isGroupMove: false})}}>Cancel</a>
                                            <p>Select which group to move nodebook to:</p>
                                            {
                                                this.state.groups.map(
                                                    group => <a key={group.id} className="ndbkitem" onClick={()=>{this.moveNodebookToGroup(group.id)}}>{group.name}</a>
                                                )
                                            }
                                        </div>
                                    )
                                : null
                        }

                    </div>
                )
            } else {
                return (
                    <div className="permissionsmngr" ref={c=>this.wrapper=c}>
                        {usersJSX}
                    </div>
                )
            }
        }
    }
}

export default withRouter(PermissionsManager)


// WEBPACK FOOTER //
// ./src/components/PermissionsManager.js